import comp from "./TimetableSync";
export default comp;
